import { MeasurementVO } from "../../../../../profiling/vo/MeasurementVO";

export class BasicProfilingTrackingCommandVO {

    /**
     * Definition of measurements to take.
     */
    public measurements: MeasurementVO[] = [];

}
